import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { getSelectedLanguage } from 'src/app/kiosk/components/transaction-info/state/transaction-info.selectors';
import { AppState } from 'src/app/state/app.state';


@Injectable()
export class LanguageInterceptor implements HttpInterceptor, OnDestroy {
  constructor(private router: Router, private store: Store<AppState>) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.pipe(select(getSelectedLanguage)).pipe(
      first(),
      switchMap(lang => {
        if (lang && lang.languageCode) {
            const newHeaders = req.headers.set('lang', lang.languageCode);

            const copiedReq = req.clone({ headers: newHeaders });
            return next.handle(copiedReq);
          } 
          else {
            return next.handle(req);
          }
      }));
  }

  ngOnDestroy(): void { }
}